import { Component } from '@angular/core';

@Component({
  selector: 'demo-custom-checkbox-value',
  templateUrl: './custom-checkbox-value.html'
})
export class DemoButtonsCustomCheckboxValueComponent {
  singleModel = '1';
}
